










































































































































































import { Component, Vue } from 'vue-property-decorator';
import { orderSendOutDetailed, orderSendOutDetailedSkuList } from '../../utils/api';

@Component({ components: {} })
export default class order_send_out_detailed extends Vue {
  currentPage = 1;
  pagesize = 20;
  totalElements = 0;
  // 数据
  dataList: any = [];
  // 第一个物流信息
  fristTime = {};
  // 创建人名称
  fullName = '';
  // 商品明细
  skuList = [];
  //物流信息
  queryTrackRespVO = [];
  data = {
    page: 0,
    size: 10,
    performanceOrderId: ''
  };
  goBack() {
    this.$router.go(-1);
  }
  mounted() {
    this.getDataList();
  }
  async getDataList() {
    try {
      const result = await orderSendOutDetailed();
      this.dataList = result;
      this.fullName = this.dataList.createdBy.fullName;
      this.skuList = this.dataList.skuList;
      console.log(this.data);
      if (this.dataList.queryTrackRespVO) {
        this.dataList.queryTrackRespVO.data.map(item => {
          item.left = item.ftime.slice(0, 10);
          item.rigth = item.ftime.slice(10);
        });
        this.queryTrackRespVO = this.dataList.queryTrackRespVO.data;
        this.fristTime = this.dataList.queryTrackRespVO.data.shift();
      }
      this.data = {
        page: 0,
        size: 10,
        performanceOrderId: this.dataList.performanceOrderId.toString()
      };
      this.getSkuList(this.data);
    } catch (error) {
      this.$message.error(error);
      console.log(error);
    }
  }
  async getSkuList(data) {
    try {
      const result = await orderSendOutDetailedSkuList(data);
      this.skuList = result;
    } catch (error) {}
  }
  //分页
  handleCurrentChange(val) {
    this.data.page = val - 1;
    this.getSkuList(this.data);
  }
}
